/**
 * @desc 银行账户-导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  body: defs.basics.BankInfoRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/bankInfo/exportBankExcel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
